import React from 'react'
import styled from 'styled-components'
import PropTypes from "prop-types"
const ParagraphError = styled.p`
color: red`
const ContactError = styled.p`
color: white`
const Error = ({ errorName, redColor }) => {

  return (
    redColor === true ? (
      <ParagraphError >{errorName}</ParagraphError>) : (<ContactError>{errorName}</ContactError>)
  )
}

export default Error;
Error.propTypes = {
  errorName: PropTypes.string,
  redColor: PropTypes.bool
}
Error.defaultProps = {
  errorName: "",
  redColor: true
}
